/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Link_ToastInputs */

const en_copy_link_toast = /** @type {(inputs: Copy_Link_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copied`)
};

const de_copy_link_toast = /** @type {(inputs: Copy_Link_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link kopiert`)
};

/**
* | output |
* | --- |
* | "Link copied" |
*
* @param {Copy_Link_ToastInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const copy_link_toast = /** @type {((inputs?: Copy_Link_ToastInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Link_ToastInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_copy_link_toast(inputs)
	return en_copy_link_toast(inputs)
});